function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function formatIt(date, format) {
  var pad = function pad(n) {
    return n < 10 ? "0".concat(n) : n;
  };

  var year = date.getFullYear();
  var month = pad(date.getMonth() + 1);
  var day = pad(date.getDate());
  var hour = pad(date.getHours());
  var min = pad(date.getMinutes());
  var sec = pad(date.getSeconds());
  return format.replace(/YYYY/g, '' + year).replace(/MM/g, '' + month).replace(/DD/g, '' + day).replace(/HH/g, '' + hour).replace(/mm/g, '' + min).replace(/ss/g, '' + sec);
}

export function formatFn(value, mode, format, useSeconds) {
  if (!value) {
    return undefined;
  }

  var formatsEnum = {
    date: 'YYYY-MM-DD',
    time: useSeconds ? 'HH:mm:ss' : 'HH:mm',
    datetime: useSeconds ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD HH:mm',
    year: 'YYYY',
    month: 'YYYY-MM'
  };

  var type = _typeof(format);

  if (type === 'string') {
    return formatIt(value, format);
  }

  if (type === 'function') {
    return format(value);
  }

  return formatIt(value, formatsEnum[mode]);
}